export function validateUsername(
  string = '',
  regex = /^[a-zA-Z0-9]+$/
) {
  return regex.test(string);
}

export function validatePassword(
  string = '',
  regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,}$/
) {
  return regex.test(string);
}

export function validatePhoneNumber(phone) {
    if (!phone) return false;
    const regexPhoneNumber = /((84|0|\+84)[3|5|7|8|9])+([0-9]{8})\b/g;
    return !!phone.match(regexPhoneNumber);
  }
